
/**
 * left dole, right hore
 */
export enum balanceSideSign {
  left = -1,
  right = 1
}
